import React from "react";

const ContentHeader = ({ title, children, authenticated }) => {
  return (
    <div className="content-header">
      <span className="title"> {title} </span>
      {children}
    </div>
  );
};

export default ContentHeader;



// WEBPACK FOOTER //
// ./src/components/ContentHeader.js